import React, { Component } from 'react'
import Scroll from 'react-scroll'

import './App.css'
import northPole from "./images/north-pole.png"
import india from "./images/india.png"
import guandao from "./images/guandao.png"
import hualian from "./images/hualian.png"
import penghu from "./images/penghu.png"
import qingdao from "./images/qingdao.png"
import argument from "./images/argument.png"


let Link = Scroll.Link;
var style = {
  display: 'none'
};

let Nav = () =>
  <nav className="hidden">
    <ul id="nav-list">
      <li>
        <Link activeClass="active" to="article1" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={northPole} alt=""/></div>
        </Link>
      </li>
      <li>
        <Link activeClass="active" to="article2" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={india} alt=""/></div>
        </Link>
      </li>
      <li>
        <Link activeClass="active" to="article3" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={guandao} alt=""/></div>
        </Link>
      </li>
      <li>
        <Link activeClass="active" to="article4" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={hualian} alt=""/></div>
        </Link>
      </li>
      <li>
        <Link activeClass="active" to="article5" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={penghu} alt=""/></div>
        </Link>
      </li>
      <li>
        <Link activeClass="active" to="article6" spy={true} smooth={true} duration={500} >
          <div className="avt"><img src={qingdao} alt=""/></div>
        </Link>
      </li>
      <li className="hot_menu">
        <Link>
          <div className="avt"><img src={argument} alt=""/></div>
        </Link>
      </li>
      <ul className="submenu">
        <li>
          <a target="_blank" href="https://theinitium.com/article/20160825-opinion-sea-1/">
          徐子軒
          </a>
        </li>
        <li>
          <a target="_blank" href="https://theinitium.com/article/20160825-opinion-sea-2/">
          杜貞儀
          </a>
        </li>
        <li>
          <a target="_blank" href="https://theinitium.com/article/20160825-opinion-sea-3/">
          郭庭君
          </a>
        </li>
      </ul>
    </ul>
    <ul id="nav-mobile">
      <li>
        <Link activeClass="active_mobile" to="article1" spy={true} smooth={true} duration={500} >
          <div className="geo">南極</div>
        </Link>
      </li>
      <li>
        <Link activeClass="active_mobile" to="article2" spy={true} smooth={true} duration={500} >
          <div className="geo">印度洋</div>
        </Link>
      </li>
      <li>
        <Link activeClass="active_mobile" to="article3" spy={true} smooth={true} duration={500} >
          <div className="geo">關島</div>
        </Link>
      </li>
      <li>
        <Link activeClass="active_mobile" to="article4" spy={true} smooth={true} duration={500} >
          <div className="geo">花蓮</div>
        </Link>
      </li>
      <li>
        <Link activeClass="active_mobile" to="article5" spy={true} smooth={true} duration={500} >
          <div className="geo">澎湖</div>
        </Link>
      </li>
      <li>
        <Link activeClass="active_mobile" to="article6" spy={true} smooth={true} duration={500} >
          <div className="geo">青島</div>
        </Link>
      </li>
      <li className="hot_menu">
        <Link>
          <div className="geo">觀點</div>
        </Link>
      </li>
      <ul className="submenu" style={style}>
        <li>
          <a href="https://theinitium.com/article/20160825-opinion-sea-1/">
          徐子軒
          </a>
        </li>
        <li>
          <a href="https://theinitium.com/article/20160825-opinion-sea-2/">
          杜貞儀
          </a>
        </li>
        <li>
          <a href="https://theinitium.com/article/20160825-opinion-sea-3/">
          郭庭君
          </a>
        </li>
      </ul>
    </ul>
  </nav>

export default Nav


/** WEBPACK FOOTER **
 ** ./src/Nav.js
 **/